<template>
  <div>
    <el-dialog :title="title" :visible="visible" :before-close="handleClose">
      <el-form
        :model="form"
        ref="productForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <div class="two-columns">
          <el-form-item
            v-for="(item, index) in fieldInfos"
            :key="index"
            :label="getLanguageValue(item.fieldName)"
            label-width="160px"
            :prop="item.fieldKey"
            :rules="generateRules(item)"
          >
            <template v-if="item.fieldType === FORM_ITEM_TYPE.SELECT">
              <!-- 电池/电池类型 -->
              <el-select
                v-if="['batterType', 'batterShow'].includes(item.fieldKey)"
                v-model="form[item.fieldKey]"
                :placeholder="getLanguageValue('请选择')"
              >
                <el-option
                  v-for="item in batterTypearr"
                  :key="item.value"
                  :label="getLanguageValue(item.label)"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- 支架类型 -->
              <el-select
                v-if="['supportId'].includes(item.fieldKey)"
                v-model="form[item.fieldKey]"
                :placeholder="getLanguageValue('请选择')"
              >
                <el-option
                  v-for="item in arr"
                  :key="item.id"
                  :label="getLanguageValue(item.supportModel)"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <!-- 单/双玻 -->
              <el-select
                v-if="['singleDou'].includes(item.fieldKey)"
                v-model="form[item.fieldKey]"
                :placeholder="getLanguageValue('请选择')"
              >
                <el-option
                  v-for="item in danshuangarr"
                  :key="item.value"
                  :label="getLanguageValue(item.label)"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
            <el-input
              v-else
              v-model="form[item.fieldKey]"
              autocomplete="off"
              :placeholder="getLanguageValue('请输入')"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{getLanguageValue('取 消')}}</el-button>
        <el-button type="primary" @click="submit()">{{getLanguageValue('确 定')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSelectableBracketModels } from "@/api/index";
import { FORM_ITEM_TYPE } from "@/utils/constant";
import { mapGetters } from "vuex";

export default {
  name: "CreateProductDialog",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    detailInfo: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters("language", ["getLanguageValue"]),
    title() {
      return this.detailInfo && this.detailInfo.id 
      ? this.getLanguageValue('编辑产品') 
      : this.getLanguageValue('新增产品')
    },
  },
  watch: {
    detailInfo: {
      handler(val) {
        this.form = Object.assign({}, this.detailInfo || {});
        // this.$refs.form.resetFields();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      FORM_ITEM_TYPE,
      fieldInfos: [
        {
          fieldKey: "componentStandard",
          fieldName: "组件规格",
          fieldType: FORM_ITEM_TYPE.STRING,
          required: true,
        },
        {
          fieldKey: "componentPower",
          fieldName: "功率(w)",
          fieldType: FORM_ITEM_TYPE.NUMBER,
          required: true,
        },
        {
          fieldKey: "componentModel",
          fieldName: "版型",
          fieldType: FORM_ITEM_TYPE.STRING,
          required: true,
        },
        {
          fieldKey: "batterType",
          fieldName: "电池",
          fieldType: FORM_ITEM_TYPE.SELECT,
          required: true,
        },
        {
          fieldKey: "batterShow",
          fieldName: "电池类型",
          fieldType: FORM_ITEM_TYPE.SELECT,
          required: true,
        },
        {
          fieldKey: "batterNum",
          fieldName: "电池片数",
          fieldType: FORM_ITEM_TYPE.NUMBER,
          required: true,
        },
        {
          fieldKey: "singleDou",
          fieldName: "单/双玻",
          fieldType: FORM_ITEM_TYPE.SELECT,
          required: true,
        },
        {
          fieldKey: "componentPrice",
          fieldName: "组件价格",
          fieldType: FORM_ITEM_TYPE.NUMBER,
          required: true,
        },
        {
          fieldKey: "componentHigh",
          fieldName: "组件高(m)",
          fieldType: FORM_ITEM_TYPE.NUMBER,
          required: true,
        },
        {
          fieldKey: "componentWidth",
          fieldName: "组件宽(m)",
          fieldType: FORM_ITEM_TYPE.NUMBER,
          required: true,
        },
        {
          fieldKey: "lifeTime",
          fieldName: "组件寿命(年)",
          fieldType: FORM_ITEM_TYPE.NUMBER,
          required: true,
        },
        {
          fieldKey: "supportId",
          fieldName: "支架类型",
          fieldType: FORM_ITEM_TYPE.SELECT,
          required: true,
        },
      ],
      batterTypearr: [
        {
          value: "p-type",
          label: "p-type",
        },
        {
          value: "n-TOPcon",
          label: "n-TOPcon",
        },
        {
          value: "n-TBC",
          label: "n-TBC",
        },
        {
          value: "n-HJT",
          label: "n-HJT",
        },
        {
          value: "n-HBC",
          label: "n-HBC",
        },
        {
          value: "TSiP",
          label: "TSiP",
        },
      ],
      batterType: [
        {
          value: "p-type",
          label: "p-type",
        },
        {
          value: "n-TOPcon",
          label: "n-TOPcon",
        },
        {
          value: "n-TBC",
          label: "n-TBC",
        },
        {
          value: "n-HJT",
          label: "n-HJT",
        },
        {
          value: "n-HBC",
          label: "n-HBC",
        },
        {
          value: "TSiP",
          label: "TSiP",
        },
      ],
      danshuangarr: [
        {
          value: "单玻",
          label: "单玻",
        },
        {
          value: "双玻",
          label: "双玻",
        },
      ],
      fileList: [],
      form: {},
      rules: {
        componentStandard: [
          { required: true, message: "组件规格不能为空", trigger: "blur" },
        ],
        componentPower: [
          { required: true, message: "功率不能为空", trigger: "blur" },
        ],
        componentModel: [
          { required: true, message: "版型不能为空", trigger: "blur" },
        ],
        batterType: [
          { required: true, message: "电池不能为空", trigger: "blur" },
        ],
        batterShow: [
          { required: true, message: "电池类型不能为空", trigger: "blur" },
        ],
        batterNum: [
          { required: true, message: "电池片数不能为空", trigger: "blur" },
        ],
        singleDou: [
          { required: true, message: "单/双玻不能为空", trigger: "blur" },
        ],
        componentPrice: [
          { required: true, message: "组件价格不能为空", trigger: "blur" },
        ],
        componentHigh: [
          { required: true, message: "组件高不能为空", trigger: "blur" },
        ],
        componentWidth: [
          { required: true, message: "组件宽不能为空", trigger: "blur" },
        ],
        lifeTime: [
          { required: true, message: "组件寿命不能为空", trigger: "blur" },
        ],
        supportId: [
          { required: true, message: "支架型号不能为空", trigger: "blur" },
        ],
      },
      // 支架类型选择列表
      arr: [],
    };
  },
  created() {},
  mounted() {
    this.getHouseSelects();
  },
  methods: {

  /**
   * 生成校验规则
   * @param {Object} item 表单字段
   */
  generateRules(item) {
    const rules = []

    // 校验多选
    if (item.multi) {
      if (item.required) {
        rules.push({
          validator: (rule, value, callback) => {
            if (value.every((val) => val === '')) {
              callback(new Error(this.getLanguageValue('请输入')))
            } else {
              callback()
            }
          },
          trigger: 'blur',
        })
      }

      // 多选时的数字或整数校验
      if (
        item.fieldType === FORM_ITEM_TYPE.NUMBER ||
        item.fieldType === FORM_ITEM_TYPE.INTEGER
      ) {
        rules.push({
          validator: (rule, value, callback) => {
            const isValid = value.every((val) => {
              if (item.fieldType === FORM_ITEM_TYPE.NUMBER) {
                // 数字类型：支持小数，最多 6 位小数
                return /^-?\d+(\.\d{1,6})?$/.test(val)
              } else if (item.fieldType === FORM_ITEM_TYPE.INTEGER) {
                // 整数类型：不支持小数
                return /^-?\d+$/.test(val)
              }
              return true
            })

            if (!isValid) {
              callback(
                new Error(
                  item.fieldType === FORM_ITEM_TYPE.NUMBER
                  ? this.getLanguageValue('请输入6位小数位内的数字')
                  : this.getLanguageValue('请输入整数')
                )
              )
            } else {
              callback()
            }
          },
          trigger: 'blur',
        })
      }
    } else {
      if(item.required) {
        // 校验必填项
        rules.push({
          required: true,
          message: this.getLanguageValue('请输入'),
          trigger: 'blur',
        })
      }
      // 数字类型校验
      if (
        item.fieldType === FORM_ITEM_TYPE.NUMBER ||
        item.fieldType === FORM_ITEM_TYPE.INTEGER
      ) {
        rules.push({
          // 正则匹配规则：数字且小数位最多 6 位
          pattern: item.fieldType === FORM_ITEM_TYPE.NUMBER
            ? /^-?\d+(\.\d{1,6})?$/ // 数字类型支持小数点，最多支持 6 位小数
            : /^-?\d+$/, // 整数类型不支持小数
          message:
            item.fieldType === FORM_ITEM_TYPE.NUMBER
              ? this.getLanguageValue('请输入6位小数位内的数字')
              : this.getLanguageValue('请输入整数'),  
          trigger: 'blur',
        })
      }
    }
    return rules
  },
    // 关闭弹窗
    handleClose() {
      this.$emit("update:visible", false);
      // this.form = {};
      // this.$refs.productForm.resetFields();
    },
    // 提交数据
    submit() {
      this.$refs.productForm.validate(async (valid) => {
        if (valid) {
          this.$emit("submit", this.form);
          this.handleClose();
        }
      });
    },
    async getHouseSelects() {
      const res = await getSelectableBracketModels();
      this.arr = res.data || [];
    },
  },
};
</script>

<style scoped>
.two-columns {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
}
</style>
